import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faLink } from "@fortawesome/free-solid-svg-icons";

type FileDetails = {
  name: string;
  type: string;
  size: string;
  dimensions?: {
    width: number;
    height: number;
    contentWidth: number;
    contentHeight: number;
    contentAspectRatio: number;
  };
};

interface FileDetailsViewerProps {
  fileDetails: FileDetails | null;
}

const FileDetailsViewer: React.FC<FileDetailsViewerProps> = ({ fileDetails }) => {
  if (!fileDetails) return null;

  const getAspectRatioString = (width: number, height: number): string => {
    const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b));
    const divisor = gcd(width, height);
    const ratioW = width / divisor;
    const ratioH = height / divisor;
    return `${ratioW}:${ratioH}`;
  };

  const getFileExtension = (type: string): string => {
    return type.split('/')[1]?.toUpperCase() || type;
  };

  return (
    <div className="flex flex-col items-center space-y-1 text-sm">
      <div className="font-semibold text-gray-700 truncate max-w-full">
        {fileDetails.name}
      </div>
      <div className="flex items-center space-x-2 text-gray-600">
        <span className="flex items-center">
          <FontAwesomeIcon 
            icon={faCircleCheck} 
            className="mr-1 text-green-400" 
            size="sm"
          />
          {getFileExtension(fileDetails.type)} • {fileDetails.size}
        </span>
        
        {fileDetails.dimensions && (
          <>
            <span className="text-gray-400">•</span>
            <span className="flex flex-row">
              {fileDetails.dimensions.contentWidth} × {fileDetails.dimensions.contentHeight}
            </span>
            <span className="text-gray-400">•</span>
            <span className="text-gray-500">
              <FontAwesomeIcon icon={faLink} className="w-4 h-4 pr-1" />
              {getAspectRatioString(
                fileDetails.dimensions.contentWidth, 
                fileDetails.dimensions.contentHeight
              )}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default FileDetailsViewer;